import {
	AZURE_SPEECH_FAMILY,
	SPEECH_PHRASE_WEIGHT_MAX,
	SPEECH_PHRASE_WEIGHT_MIN,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type SpeechShape = {
	readonly family: string | null;
	readonly hasAzureSpeechSettings: boolean;
};

/** Active only when the Azure Speech settings section is shown. Empty means "Microsoft's own weight". */
function isSpeechPhraseWeightValid<T extends SpeechShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || !formData.hasAzureSpeechSettings || value.trim() === '') {
		return true;
	}

	const weight = Number(value);

	return (
		Number.isFinite(weight) && weight >= SPEECH_PHRASE_WEIGHT_MIN && weight <= SPEECH_PHRASE_WEIGHT_MAX
	);
}

export default isSpeechPhraseWeightValid;
